<template>
    <div class="blast-info">
        <div class="display-flex justify-between px-5 pb-3 border-bottom">
            <div>{{ $translate('tSB') }}</div>
            <div>{{ $translate('tB') }}</div>
            <div>{{ $translate('tEB') }}</div>
        </div>

        <div class="display-flex justify-between px-5 py-3 border-bottom">
            <i class="fa fa-circle-o" />
            <div class="h-divider-wide-light mb-15 w-100"></div>
            <i class="fa fa-circle-o" />
        </div>

        <div class="display-flex justify-between px-5 pt-3 pb-5 border-bottom">
            <div>{{ $uiUtils.formatHourSinceFertilization(mkEventsMap['tsb'].value) }}h</div>
            <div>{{ $uiUtils.formatHourSinceFertilization(mkEventsMap['tb'].value) }}h</div>
            <div>{{ $uiUtils.formatHourSinceFertilization(mkEventsMap['teb'].value) }}h</div>
        </div>

        <div class="flex-column blast_info_details">
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('time_between_tsb_teb') }}</span>
                <span>
                    {{
                        $uiUtils.formatHourSinceFertilization(
                            mkEventsMap['teb'].value - mkEventsMap['tsb'].value
                        )
                    }}h
                </span>
            </div>
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('blast_diameter') }}</span>
                <span>{{ blastInfo.blastDiameter }}</span>
            </div>
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('icm_size') }}</span>
                <span>{{ blastInfo.icmSize }}</span>
            </div>
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('icm_shape') }}</span>
                <span>{{ blastInfo.icmShape }}</span>
            </div>
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('ratio_between_icm_te') }}</span>
                <span>{{ blastInfo.ratioBetweenIcmTe }}</span>
            </div>
            <div class="justify-between border-bottom py-2 px-5">
                <span class="title pr-2">{{ $translate('num_of_collapses') }}</span>
                <b-button
                    class="ml-auto text-underline mt--1 mr-4"
                    size="sm"
                    variant="link"
                    @click="openBlastCollapsesDialog"
                >
                    {{ $translate('view_collapses') }}
                </b-button>
                <span>{{ blastInfo.numOfCollapse }}</span>
            </div>
        </div>

        <div
            class="
                display-flex
                justify-between
                blast-info-rank-contrainer
                px-5
                py-4
                text-size-13
                mx-5
            "
        >
            <div class="mr-2" :class="blastInfo.quality === 'top' ? 'text-primary text-bold' : ''">
                {{ $translate('top') }}
            </div>
            <div
                class="mr-2"
                :class="blastInfo.quality === 'good' ? 'rag-green-text text-bold' : ''"
            >
                {{ $translate('good') }}
            </div>
            <div :class="blastInfo.quality === 'poor' ? 'rag-red-text text-bold' : ''">
                {{ $translate('poor') }}
            </div>
        </div>

        <div class="blast-info-bottom-container flex-column px-3">
            <div class="px-3 pt-3 pb-2 mx-5 adjust-gardner-container justify-between text-light-2">
                <adjust-gardner-dialog class="bottom-5" />

                <span v-html="$translate('adjust_clinic_gardner')"> </span>

                <b-button
                    variant="transparent"
                    class="mb-2 text-light-2"
                    @click="openAdjustGardnerDialog"
                >
                    <i class="fa fa-pencil"></i>
                </b-button>

                <div class="flex-column">
                    <span type="text" class="adjust-gardner-value-box">
                        {{ gardnerScore && gardnerScore.blastStage }}
                    </span>
                    <span class="text-size-7 text-center mt-1">1-4</span>
                </div>

                <div class="flex-column">
                    <span type="text" class="adjust-gardner-value-box">
                        {{ gardnerScore && gardnerScore.innerCellMass }}
                    </span>
                    <span class="text-size-7 text-center mt-1">A-C</span>
                </div>

                <div class="flex-column">
                    <span type="text" class="adjust-gardner-value-box">
                        {{ gardnerScore && gardnerScore.trophectoderm }}
                    </span>
                    <span class="text-size-7 text-center mt-1">A-C</span>
                </div>
            </div>

            <div class="mt-4 w-100 justify-center recalculate-button-container">
                <b-button
                    size="lg"
                    class="display-flex rounded py-2 align-items-center"
                    variant="primary"
                >
                    <span class="text-size-21 mr-4 ml-4 pl-5 kid-plus-text">
                        {{ $translate('kid_plus') }}
                    </span>
                    <span class="text-size-15 mt-1 mr-5 pr-5">{{ $translate('calculate') }}</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import Segmentations from '../../../mock/data/Segmentations'
import AdjustGardnerDialog from './common/AdjustGardnerDialog'
import UIUtils from '../../business/utils/UIUtils'

export default {
    name: 'BlastInfo',
    components: { AdjustGardnerDialog },
    props: {
        well: {
            type: Object,
            required: true
        },
        isDemo: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        blastInfo() {
            return this.well.inferenceData.blastInfo
        },
        segmentations() {
            if (this.isDemo) return Segmentations

            return this.well.inferenceData.segmentations
        },
        mkEventsMap() {
            return this.well.mkEventsMap
        },
        runs() {
            return this.well.runs
        },
        gardnerScore() {
            return this.well.inferenceData.gardnerScore
        }
    },
    mounted() {
        console.log('BlastInfo mounted')
    },
    methods: {
        openAdjustGardnerDialog() {
            this.$store.state.timelapse.showAdjustGardnerDialog = true
        },
        openBlastCollapsesDialog() {
            UIUtils.showModal('blast_collapses', data => {
                const collapses = this.blastInfo.collapses

                data.segmentations = this.segmentations
                data.blastCollapses = collapses
                data.runs = this.runs
                data.selectedBlastCollapse = collapses.length > 0 ? collapses[0] : null
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.blast-info {
    display: flex;
    flex-flow: column;
    flex-direction: column;

    .border-bottom {
        border-color: $dark-4 !important;
    }

    .blast_info_details {
        .border-bottom {
            &:hover {
                background-color: lighten($dark, 2);
            }
        }
    }

    .adjust-gardner-container {
        background-color: $dark-4;
        border: solid 0.12rem $light-3;
        border-radius: 0.3rem;

        .adjust-gardner-value-box {
            background-color: $dark-2;
            border: solid 0.11rem $light-3;
            border-radius: 0.3rem;
            text-transform: uppercase;
            color: $light-3;
            font-size: 16pt;
            text-align: center;
            height: 2.4rem;
            width: 2.4rem;
        }
    }
}

@media screen and #{$new-break4close} {
    .focused-well {
        .blast-info {
            font-size: 9pt;
            padding-top: 2rem;
            width: calc(34vw - 5rem);
            word-wrap: normal;

            .px-5 {
                padding-left: 0.1rem !important;
                padding-right: 0.1rem !important;
            }

            .blast-info-bottom-container {
                align-items: center;
                flex-direction: row !important;
                position: fixed;
                bottom: $well-video-controls-bottom-panel-height;
                right: 0;
                width: 100vw;
                background-color: $dark-3;
                z-index: 21;

                .adjust-gardner-container {
                    width: 100%;
                    border: none;
                    background-color: $dark-3;
                }
            }

            .blast-info-rank-contrainer {
                margin-right: 0 !important;
                margin-left: 0 !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
            }

            .recalculate-button-container {
                margin-top: 0 !important;
                justify-content: flex-end;

                .btn {
                    .kid-plus-text {
                        font-size: 12pt !important;
                    }

                    span {
                        font-size: 10pt !important;
                        font-weight: bold;
                        margin-top: 0 !important;
                        padding-right: 0 !important;
                        padding-left: 0 !important;
                    }
                }
            }
        }
    }
}
</style>
